import React from 'react';
import { errorMessageOf } from './errors';
import { func, object } from 'prop-types';
import { useTranslate } from '../../../translate/I18n';
import { Controller } from 'react-hook-form';
import InputPhoneWithLabel from '../../molecules/form/InputPhoneWithLabel';
import { isPhoneFilled, isPhoneNumberValid } from '../../molecules/form/InputPhone';

/**
 * @param {FormContextValues} formHook
 * @param {string} name
 * @param {string} errorMessage
 * @param {function():any}globalOnChange
 * @param {*} props
 * @returns {*}
 */
const PhoneNumber = ({ formHook, name, errorMessage, onChange: globalOnChange = () => null, ...props }) => {
  const { t } = useTranslate(['validation', 'common']);
  return (
    <Controller
      rules={{
        validate: {
          fillPhoneNumber: isPhoneFilled,
          wrongPhone: isPhoneNumberValid
        }
      }}
      control={formHook.control}
      name={name}
      render={({ onChange, value }) => (
        <InputPhoneWithLabel
          label={t('common:phoneNumber')}
          onChange={({ value }) => {
            onChange(value);
            globalOnChange();
          }}
          errorMessage={errorMessage || errorMessageOf(t, name, formHook.errors)}
          value={value}
          name={name}
          {...props}
        />
      )}
    />
  );
};

PhoneNumber.propTypes = {
  ...InputPhoneWithLabel.propTypes,
  onChange: func,
  formHook: object
};
PhoneNumber.defaultProps = {
  name: 'phone'
};

export default PhoneNumber;
